module.exports = __webpack_public_path__ + "static/media/pensioner-4.160614f4.png";